import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
export var AppLink = styled.a.withConfig({
  displayName: "AppLink",
  componentId: "sc-1iw8l8l-0"
})(["color:", ";", ";transition:opacity 0.25s ease;&:hover{opacity:0.75;}"], function (_ref) {
  var theme = _ref.theme,
    _ref$white = _ref.white,
    white = _ref$white === void 0 ? false : _ref$white,
    _ref$black = _ref.black,
    black = _ref$black === void 0 ? false : _ref$black;
  return white ? '#fff' : black ? theme.colors.terciaryD : theme.linkColor;
}, function (_ref2) {
  var white = _ref2.white;
  return white && fontSmoothing;
});